import { Card, Heading, Inline, Text } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import { duration as durationUtil } from '@eti/utils';
import { useState } from 'react';
import { CABIN_UPGRADE } from '../../../products';
import CabinUpgradeOptOutCheckbox from './CabinUpgradeOptOutCheckbox';
import CabinUpgradeAvailableOptions from './CabinUpgradeAvailableOptions';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const availableSegmentHeadingStyles = css`
  @media ${mediaQueries.small.only} {
    align-items: flex-start;
    flex-direction: column;
  }

  justify-content: space-between;
`;
const cardSelectionTextStyles = css`
  margin: 8px 0;
`;
const CabinUpgradeAvailableSegmentCard = _ref => {
  let {
    drawerTexts,
    originDestinationAirportAriaLabelText,
    originDestinationAirportHeading,
    segmentKey,
    segmentUpgrade,
    selectedOptions,
    setSelectedOptions
  } = _ref;
  const [segmentsWithoutUpgrade, setSegmentsWithoutUpgrade] = useState({});
  const {
    checkboxSelectionLabel,
    drawerCardFlightDuration,
    drawerCardSelectionTitle
  } = drawerTexts;
  return /*#__PURE__*/_jsxs(Card, {
    "data-testid": `${CABIN_UPGRADE.name}-selection-card-available-${segmentKey}`,
    children: [/*#__PURE__*/_jsxs(Inline, {
      className: availableSegmentHeadingStyles,
      spacing: 8,
      children: [/*#__PURE__*/_jsx(Heading, {
        "aria-label": originDestinationAirportAriaLabelText,
        "data-testid": `${CABIN_UPGRADE.name}-origin-destination-heading-${segmentKey}`,
        level: 3,
        children: originDestinationAirportHeading !== null && originDestinationAirportHeading !== void 0 ? originDestinationAirportHeading : ''
      }), segmentUpgrade.duration && /*#__PURE__*/_jsxs(Inline, {
        "data-testid": `${CABIN_UPGRADE.name}-flight-duration-${segmentKey}`,
        spacing: 4,
        children: [/*#__PURE__*/_jsx(Text, {
          children: drawerCardFlightDuration
        }), /*#__PURE__*/_jsx(Text, {
          variant: "14-bold",
          children: durationUtil.getDuration(segmentUpgrade.duration)
        })]
      })]
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      className: cardSelectionTextStyles,
      "data-testid": `${CABIN_UPGRADE.name}-heading-${segmentKey}`,
      variant: "16-bold",
      children: drawerCardSelectionTitle
    }), /*#__PURE__*/_jsx(CabinUpgradeAvailableOptions, {
      drawerTexts: drawerTexts,
      segmentKey: segmentKey,
      segmentUpgrade: segmentUpgrade,
      selectedOptions: selectedOptions,
      setSegmentsWithoutUpgrade: setSegmentsWithoutUpgrade,
      setSelectedOptions: setSelectedOptions
    }), /*#__PURE__*/_jsx(CabinUpgradeOptOutCheckbox, {
      checkboxSelectionLabel: checkboxSelectionLabel,
      segmentKey: segmentKey,
      segmentsWithoutUpgrade: segmentsWithoutUpgrade,
      setSegmentsWithoutUpgrade: setSegmentsWithoutUpgrade,
      setSelectedOptions: setSelectedOptions
    })]
  }, segmentKey);
};
export default CabinUpgradeAvailableSegmentCard;
//# sourceMappingURL=CabinUpgradeAvailableSegmentCard.js.map